import { render, staticRenderFns } from "./add-new-customer-form.vue?vue&type=template&id=6d7ecf54&"
import script from "./add-new-customer-form.vue?vue&type=script&lang=ts&"
export * from "./add-new-customer-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports